/*
* @Author: yongwenhao
* @Date: 2020-04-17 09:51:22
* @describe: 招聘管理
*/
import axios from './http'

// 获取招聘职位信息
export const GetOfferList = params => {
    return axios.get("/positions/list", {params}).then(res => res.data)
};
// 新增招聘职位
export const PostAddOffer = params => {
    return axios.post("/positions/add", params).then(res => res.data)
};
// 招聘职位修改
export const PutEditOffer = params => {
    return axios.put("/positions/update", params).then(res => res.data)
};
// 招聘职位删除
export const DelOffer = positionId => {
    return axios.delete(`/positions/delete/${positionId}`).then(res => res.data)
};

// 发布公司领导者
export const PostPubOffer = positionId => {
    return axios.put(`/positions/publish/${positionId}`).then(res => res.data)
};
// 下架公司领导者
export const PostOutOffer = positionId => {
    return axios.put(`/positions/not-publish/${positionId}`).then(res => res.data)
};
